import React from "react";
import { PageSection } from "@/components/AppLayout.jsx";
import { AdminGuard } from "@/components/admin/AdminGuard.jsx";
import { useI18n } from "@/coquille-bridge";
import {
  AuthorityDocumentsPanel,
  EvidenceDossiersPanel,
  ValidationLogPanel,
  SecurityFuturePanel,
  SenseiTitleDocumentsPanel,
  SempaiTitleDocumentsPanel,
  CentralDocumentsLink,
} from "@/components/authority/KarateAuthorityDocumentsPanels.jsx";

function useLocale() {
  const { lang } = useI18n();
  return lang === "en" ? "en" : "fr";
}

export function AdminAuthorityDocumentsPage({ scope = "shotokan", showCentralLink = true } = {}) {
  return (
    <div data-testid="page-admin-documents-autorite">
      {showCentralLink ? <CentralDocumentsLink testId="shotokan-central-documents-link" /> : null}
      <AuthorityDocumentsPanel mode="admin" scope={scope} />
      {scope === "shotokan" ? <SecurityFuturePanel /> : null}
    </div>
  );
}

export function AdminEvidenceDossiersPage({ showCentralLink = true } = {}) {
  return (
    <div data-testid="page-admin-dossiers-preuves">
      {showCentralLink ? <CentralDocumentsLink testId="shotokan-central-dossiers-link" /> : null}
      <EvidenceDossiersPanel />
    </div>
  );
}

export function AdminValidationLogPage({ showCentralLink = true } = {}) {
  return (
    <div data-testid="page-admin-journal-validation">
      {showCentralLink ? <CentralDocumentsLink testId="shotokan-central-journal-link" /> : null}
      <ValidationLogPanel />
    </div>
  );
}

export function SenseiTitleDocumentsPage() {
  const locale = useLocale();
  return (
    <PageSection
      title={locale === "en" ? "Title application documents" : "Documents titres"}
      testId="page-sensei-documents-titres"
    >
      <SenseiTitleDocumentsPanel />
    </PageSection>
  );
}

export function SempaiTitleDocumentsPage() {
  const locale = useLocale();
  return (
    <PageSection
      title={locale === "en" ? "Required proofs (consult)" : "Documents titres (consultation)"}
      testId="page-sempai-documents-titres"
    >
      <SempaiTitleDocumentsPanel />
    </PageSection>
  );
}
